<template>
    <div class="col-12 sm:col-5 md:col-4 xl:col-3 test">
        <div class="flex flex-column gap-2 category-btn">
            <Button v-for="category in Object.keys(filters())" :key="category" text severity="contrast"
                :disabled="isCategorySelected(category)" @click="onCategoryClick(category)">
                <span class="text-2xl font-bold py-1 px-3 uppercase" style="color: #aaaaaa;">{{ category }}</span>
            </Button>
            <div class="flex gap-2 px-5 mt-4">
                <CreateQueueButton class="js-curve-compare-screenshot-btn" :selectors="[
                { name: '.highcharts-root', height: 180, width: 500 },
                { name: '.highcharts-compare', height: 50, width: 500 },
            ]" />
                <Button class="border-round-xl w-9 py-2 px-3 clear-all-btn js-clear-curves" severity="secondary"
                    @click="chartStore.clearAll()">
                    <span class="uppercase font-bold text-xl mx-auto">Clear</span>
                </Button>
            </div>
        </div>
    </div>
    <div class="col-12 sm:col-7 md:col-8 xl:col-9">
        <div class="px-4 -mt-5">
            <Panel v-for="filters, symbol, key in getCategoryFilters(chartStore.selectedCategory)" :key="symbol"
                class="filter-list" :collapsed="key !== panelOpened" toggleable @toggle="onPanelToggleClick(key)">
                <template #header @click="onPanelToggleClick(key)">
                    <span class="text-lg font-bold">{{ symbol }}</span>
                </template>
                <div class="flex flex-wrap gap-4 m-4">
                    <Chip v-for="filter in filters" :key="filter.title" class="js-group-filter pl-2 pr-6 py-2"
                        :style="{ 'background-color': chartStore.isItemEnabled(filter.title) ? '#afafaf' : '#ffffff' }"
                        :class="{ '_enabled': chartStore.isItemEnabled(filter.title) }"
                        :data-permalink="filter.permalink" :data-category="chartStore.selectedCategory"
                        :data-curve-slug="filter.slug" :data-curve-title="filter.title" :data-curve-color="filter.color"
                        :data-curve-json-path="filter.jsonPath">
                        <span class="border-circle w-3rem h-3rem" :style="{ 'background-color': filter.color }"></span>
                        <span class="ml-4 text-lg font-bold text-900">{{ filter.title }}</span>
                    </Chip>
                </div>
            </Panel>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { useAppStore } from '@/stores/app';
import { useChartStore } from '@/stores/highcharts';
import { filters } from '@/filters/filters';
import CreateQueueButton from '@/components/CreateQueueButton.vue';

const DEFAULT_PANEL = 0;

const panelOpened = ref(DEFAULT_PANEL);
const selectedFilters = ref(filters());
const appStore = useAppStore();
const chartStore = useChartStore();

const emit = defineEmits(['change']);
const props = defineProps(['category-selected']);

const isCategorySelected = (category) => {
    return chartStore.selectedCategory.toLowerCase() === category.toLowerCase();
};

const onCategoryClick = (category) => {
    panelOpened.value = DEFAULT_PANEL;
    chartStore.selectedCategory = category;
};

const getCategoryFilters = (category) => {
    return selectedFilters.value[category] ?? [];
};

const onPanelToggleClick = (data) => {
    panelOpened.value = data;
};

</script>

<style scoped>
.js-group-filter {
    cursor: pointer;
    background-color: white;
    border-radius: 2rem;
}

.p-divider.p-divider-horizontal:before {
    border-radius: 0.25rem;
    border-top: .25rem solid #c1c1c1;
}

.category-btn>.p-disabled,
.category-btn>.p-component:disabled {
    opacity: 1 !important;
}

.category-btn>.p-disabled>span,
.category-btn>.p-component:disabled>span {
    color: black !important;
}

.clear-all-btn {
    background-color: #9b9b9b;
    border-color: #9b9b9b;
}

.p-panel.p-panel-content {
    background-color: #e9e9e9 !important;
    border-bottom-color: #e9e9e9 !important;
}

:deep(.p-panel-header),
:deep(.p-panel-content) {
    background-color: #e9e9e9 !important;
    border-top-color: #e9e9e9 !important;
    border-left-color: #e9e9e9 !important;
    border-right-color: #e9e9e9 !important;
}

:deep(.p-panel-header) {
    border-bottom: .25rem solid #c1c1c1;
}

:deep(.p-panel-toggler) {
    width: 5rem;
    height: 5rem;
}

table {
    font-size: 14px;
    text-align: center;
    border: 1px solid #ccc;
    border-collapse: collapse;

    th {
        background: #ddd;
        font-weight: bold;
    }

    td,
    th {
        padding: 8px;
        border: 1px solid #ccc;
    }
}
</style>